
import { baseApi} from '../utils/api'

// 获取租户信息
export const getZgTenantByDomain = (data) => {
    return baseApi({
      url: '/zgTenant/getZgTenantByDomain',
      method: 'post',
      data
    })
  }